// import { CustomImage } from '@intigral/shared/components/CustomImage';
import React from 'react';
import styles from './details.module.sass';
import cn from 'classnames';
import { Lock } from '../Lock';
import { Quality4K } from '../SVGIcons/Quality4K';
import { Dolby } from '../SVGIcons/Dolby';

export interface MovieDetailsProps extends React.HTMLAttributes<HTMLDivElement> {
    provider?: [string, number?, number?];
    locked?: boolean;
    dolby?: boolean;
    quality4K?: boolean;
    onClickLock?: () => void;
    rating?: string;
    info?: (string | string[] | { [key: string]: string[] })[];
    live?: string;
    catchup?: string;
}

export function isValidProviderProp(provider: any): provider is [string, number?, number?] {
    if (!Array.isArray(provider)) {
        return false;
    }
    if (typeof provider[0] !== 'string' || provider[0].trim() === '') {
        return false;
    }
    if (provider[1] !== undefined && typeof provider[1] !== 'number') {
        return false;
    }
    if (provider[2] !== undefined && typeof provider[2] !== 'number') {
        return false;
    }
    // Valid if all conditions are met
    return true;
}

export const MovieDetails = ({
    provider,
    locked,
    dolby,
    quality4K,
    onClickLock = () => undefined,
    rating,
    info,
    live,
    catchup,
    className,
    ...props
}: MovieDetailsProps) => {
    if (!isValidProviderProp(provider)) {
        // render some fallback UI
    }

    let counter = 0;

    return (
        <div className={cn(className, styles.details)} {...props}>
            {locked && (
                <div className={styles.lock} onClick={() => locked && onClickLock()}>
                    <Lock inline small />
                </div>
            )}
            {isValidProviderProp(provider) && (
                <div className={styles.provider}>
                    <img src={provider[0]} width={provider[1] || 'auto'} height={provider[2] || 24} alt="" />
                </div>
            )}
            {(live || catchup) && (
                <span className={cn(styles.age, live && styles.live, catchup && styles.catchup)}>
                    {live || catchup}
                </span>
            )}
            {dolby && (
                <span>
                    <Dolby />
                </span>
            )}
            {quality4K && (
                <>
                    <span>
                        <Quality4K />
                    </span>
                    <span className={styles.divide} />
                </>
            )}
            {info &&
                Array.isArray(info) &&
                info
                    .filter(
                        (item) =>
                            (typeof item === 'string' && item !== '') ||
                            Array.isArray(item) ||
                            (typeof item === 'object' && !Array.isArray(item))
                    )
                    .map((item, index) => (
                        <React.Fragment key={index}>
                            {typeof item === 'string' && <span>{item}</span>}
                            {Array.isArray(item) &&
                                item
                                    .filter((nestedItem) => typeof nestedItem === 'string')
                                    .map((nestedItem, nestedIndex) => (
                                        <span key={`${index}-${nestedIndex}`}>{nestedItem}</span>
                                    ))}
                            {typeof item === 'object' &&
                                item !== null &&
                                !Array.isArray(item) &&
                                Object.keys(item)
                                    .filter((item) => typeof item === 'string')
                                    .map((key) => {
                                        const isFirstObject = counter === 0;
                                        counter++;
                                        return (
                                            <div key={`${index}-${key}`}>
                                                <div className={isFirstObject ? styles.inner : ''}>
                                                    <strong>{key}: </strong>
                                                    {item[key].filter((value) => typeof value === 'string').join(', ')}
                                                </div>
                                            </div>
                                        );
                                    })}
                        </React.Fragment>
                    ))}
            {rating && (
                <span className={styles.age} data-test-id="rating">
                    {rating}
                </span>
            )}
        </div>
    );
};

// const decodeHtmlEntities = (str) => {
//     const textArea = document.createElement('textarea');
//     textArea.innerHTML = str;
//     return textArea.value;
// };

// const encodedString = "Children&apos;s Literature";
// const decodedString = decodeHtmlEntities(encodedString);
// console.log(decodedString);  // Output: "Children's Literature"
